module.exports = __webpack_public_path__ + "img/platform.ff584af.png";